import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between h-16 px-4 md:px-20">
        <Link
          to={`/parcel/search-product${location.search}`}
          className="text-center flex-1"
        >
          <span
            className="font-bold text-lg text-gray-800 
            md:absolute md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2"
          >
            코리아보드게임즈 배송 신청
          </span>
        </Link>
        <Link
          to={`/parcel/cart${location.search}`}
          className="flex items-center bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
        >
          <span className="font-semibold">장바구니</span>
        </Link>
      </div>
    </div>
  );
}
